<template>
  <div class="c-gauge-style">
    <el-collapse>
      <el-collapse-item title="仪表盘样式">
        <el-form-item>
          <div class="chart-form-item-warp">
            <span class="jz-chart-title-label">主题色</span>
            <el-color-picker v-model="selectItem.styleConfig.commongConfig.gaugeThemeColor" />
          </div>
        </el-form-item>
        <el-form-item>
          <div class="chart-form-item-warp" style="margin-top: 0">
            <span class="jz-chart-title-label">透明度</span>
            <el-slider style="flex:1" v-model="selectItem.styleConfig.commongConfig.gaugeThemeOpacity"></el-slider>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="chart-form-item-warp" style="margin-top: 0">
            <span class="jz-chart-title-label">半径占比</span>
            <el-slider style="flex:1" v-model="selectItem.styleConfig.commongConfig.gaugeRadiusRatio"></el-slider>
          </div>
        </el-form-item>
        <el-form-item>
          <style-sub-item title="内部刻度线">
            <div class="chart-form-item-warp" style="margin-top: 0">
              <span class="jz-chart-title-label">是否开启</span>
              <el-switch v-model="selectItem.styleConfig.commongConfig.gaugeInnerTickEnable">
              </el-switch>
            </div>
            <div class="chart-form-item-warp" style="margin-top: 12px">
              <span class="jz-chart-title-label">刻度线形式</span>
              <el-radio-group v-model="selectItem.styleConfig.commongConfig.gaugeInnerTick">
                <el-radio :label="1">显示原值</el-radio>
                <el-radio :label="0">显示百分比</el-radio>
              </el-radio-group>
            </div>
          </style-sub-item>
        </el-form-item>
      </el-collapse-item>
      <el-collapse-item title="数据标签">
        <style-sub-item style="margin-top: 12px;padding:12px" class="c-bi-dashboard-text-style" title="主标签">
          <div class="chart-form-item-warp">
            <span class="jz-chart-title-label">
              标签样式
            </span>
            <el-radio-group v-model="selectItem.styleConfig.commongConfig.gaugeLabelStyle">
              <el-radio :label="1">显示指标值</el-radio>
              <el-radio :label="0">显示百分比</el-radio>
            </el-radio-group>
          </div>
          <el-form-item style="margin-bottom: 12px">
            <div>名称</div>
            <div class="chart-form-item-warp">
              <span class="jz-chart-title-label">
                字体颜色
              </span>
              <el-color-picker
                v-model="selectItem.styleConfig.commongConfig.labelConfig.textConfig.labelColor"></el-color-picker>
            </div>
            <div class="chart-form-item-warp">
              <span class="jz-chart-title-label">
                字体大小
              </span>
              <el-input-number v-model="selectItem.styleConfig.commongConfig.labelConfig.textConfig.labelFontSize"
                :min="12" :max="20" :step="1" controls-position="right"></el-input-number>
            </div>
            <div class="chart-form-item-warp">
              <span class="jz-chart-title-label">
                加粗
              </span>
              <el-switch v-model="selectItem.styleConfig.commongConfig.labelConfig.textConfig.labelIsBold"></el-switch>
            </div>
            <div class="chart-form-item-warp">
              <span class="jz-chart-title-label">
                斜体
              </span>
              <el-switch
                v-model="selectItem.styleConfig.commongConfig.labelConfig.textConfig.labelIsItalic"></el-switch>
            </div>
          </el-form-item>
          <el-form-item style="margin-bottom: 12px">
            <div>数值</div>
            <div class="chart-form-item-warp">
              <span class="jz-chart-title-label">
                字体颜色
              </span>
              <el-color-picker
                v-model="selectItem.styleConfig.commongConfig.labelConfig.textConfig.valueColor"></el-color-picker>
            </div>
            <div class="chart-form-item-warp">
              <span class="jz-chart-title-label">
                字体大小
              </span>
              <el-input-number v-model="selectItem.styleConfig.commongConfig.labelConfig.textConfig.valueFontSize"
                :min="12" :max="20" :step="1" controls-position="right"></el-input-number>
            </div>
            <div class="chart-form-item-warp">
              <span class="jz-chart-title-label">
                加粗
              </span>
              <el-switch v-model="selectItem.styleConfig.commongConfig.labelConfig.textConfig.valueIsBold"></el-switch>
            </div>
            <div class="chart-form-item-warp">
              <span class="jz-chart-title-label">
                斜体
              </span>
              <el-switch
                v-model="selectItem.styleConfig.commongConfig.labelConfig.textConfig.valueIsItalic"></el-switch>
            </div>
          </el-form-item>
          <div class="chart-form-item-warp" v-show="selectItem.styleConfig.commongConfig.gaugeLabelStyle === 0">
            <span class="jz-chart-title-label">
              占比值小数位数
            </span>
            <el-select size="small" v-model="selectItem.styleConfig.commongConfig.labelConfig.textConfig.labelDecimalPlaces"
              placeholder="请选择" popper-class="c-select-style-popper">
              <el-option v-for="option in decimalPlacesOptions" :key="option.value" :label="option.label"
                :value="option.value">
              </el-option>
            </el-select>
          </div>
        </style-sub-item>
        <style-sub-item style="margin-top: 12px;padding:12px" class="c-bi-dashboard-text-style" title="副标签">
          <el-form-item>
            <div class="chart-form-item-warp">
              <span class="jz-chart-title-label">
                是否开启
              </span>
              <el-switch
              size="small"
                v-model="selectItem.styleConfig.commongConfig.labelConfig.textConfig.isShow"></el-switch>
            </div>
            <div class="chart-form-item-warp">
              <span class="jz-chart-title-label">
                字体颜色
              </span>
              <el-color-picker
              size="small"
                v-model="selectItem.styleConfig.commongConfig.labelConfig.textConfig.color"></el-color-picker>
            </div>
            <div class="chart-form-item-warp">
              <span class="jz-chart-title-label">
                字体大小
              </span>
              <el-input-number v-model="selectItem.styleConfig.commongConfig.labelConfig.textConfig.fontSize" :min="12"
                :max="20" :step="1" controls-position="right" size="small"></el-input-number>
            </div>
            <div class="chart-form-item-warp">
              <span class="jz-chart-title-label">
                加粗
              </span>
              <el-switch v-model="selectItem.styleConfig.commongConfig.labelConfig.textConfig.isBold" size="small"></el-switch>
            </div>
            <div class="chart-form-item-warp">
              <span class="jz-chart-title-label">
                斜体
              </span>
              <el-switch v-model="selectItem.styleConfig.commongConfig.labelConfig.textConfig.isItalic" size="small"></el-switch>
            </div>
          </el-form-item>
        </style-sub-item>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import styleSubItem from '../base/styleSubItem.vue'
import { transferObjectToArray, getFieldValueByCustomKey } from '../../utils/index'
import { customKey } from '../../utils/enum.data'
import textStyle from '../base/textStyle.vue'
export default {
  name: 'cColumnStyle',
  components: {
    styleSubItem,
    textStyle,
  },
  props: {
    selectItem: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      getFieldValueByCustomKey,
      customKey,
      decimalPlacesOptions: [
        { label: '0', value: 0 },
        { label: '1', value: 1 },
        { label: '2', value: 2 }
      ]
    }
  },
  computed: {
    dataList() {
      return transferObjectToArray(this.selectItem)
    }
  },
  methods: {
    handleChange(item) {
      this.$set(this.selectItem.styleConfig.helperData.fieldMap[item.key], customKey + 'seriesColor', item[customKey + 'seriesColor'])
    },
    formatTooltip(value) {
      return `${value}%`
    }
  }
}
</script>
<style scoped lang="less">
.c-pie-style {
  .c-pie-style-theme {
    &:not(:first-child) {
      margin-top: 2px;
    }

    display: flex;
    align-items: center;
    margin-bottom: 2px;
    background: #323744;
    padding: 6px 12px;

    span {
      flex: 1;
      text-align: left;
      margin-left: 8px;
    }

    .el-color-picker {
      width: 26px;
    }
  }

  // 暗黑主题样式覆盖
  /deep/ .el-select-dropdown {
    background-color: #2c2f36 !important;
    border: 1px solid #404040 !important;
  }

  /deep/ .el-select-dropdown__item {
    background-color: #2c2f36 !important;
    color: #ffffff !important;

    &:hover {
      background-color: #404040 !important;
    }

    &.selected {
      background-color: #1890ff !important;
      color: #ffffff !important;
    }
  }

  /deep/ .el-select-dropdown__empty {
    color: #909399 !important;
  }
}

// 全局样式，用于覆盖 popper 渲染到 body 中的下拉框</style>